import { createSlice } from "@reduxjs/toolkit";

const legalDocSlice = createSlice({
  name: "legalDoc",
  initialState: {
    isLoading: false,
    legalDocList: [],
    isError: false,
    res: null,
  },
  reducers: {
    getLegalDocList(state, action) {
      // To save document list in redux store
      state.legalDocList = [...action.payload];
    },
    clearLegalDocs: (state) => {
      // To clear the document list stored in redux store
      state.legalDocList = [];
    },
    removeLegalDoc: (state, action) => {
      // To remove the document from redux store
      state.legalDocList = state.legalDocList.filter(
        (list) => list.docId !== action?.payload?.docId
      );
    },
  },
});

export const { getLegalDocList, clearLegalDocs, removeLegalDoc } =
  legalDocSlice.actions;
export default legalDocSlice.reducer;
